<template>
	<div>
		<load-more
			@getMore="getOrderList(false)"
			@reload="getOrderList(true)"
			ref="my_loadmore"
			:style="{ height: wrapperHeight + 'px' }"
		>
			<NoNavIndexList class="setHeight">
				<mt-index-section
					v-for="(orders, key) in orderGroups"
					:key="key"
					:index="getSectionText(key)"
				>
					<div v-if="orders.length > 0">
						<Card
							v-for="(order, index) in orders"
							:key="index"
							:headerClass="getCardHeaderClass(order)"
						>
							<template #header>
								<div class="card-item">
									<span class="card-item-label"> {{ $t('distributor.errand.status') }} </span>
									<div class="card-item-value">
										{{ getOrderStateText(order) }}
									</div>
								</div>
								<div class="card-item">
									<span class="card-item-label"> {{ $t('distributor.errand.pickup_time') }} </span>
									<div class="card-item-value">
										{{ formatTime(order.o2o_errand_order_appointment_time) }}
									</div>
								</div>
								<div class="card-item">
									<span class="card-item-label"> {{ $t('distributor.errand.on_behalf_amount') }} </span>
									<div class="card-item-value">
										{{ utils.currencyPrice(order.o2o_errand_order_pay_on_behalf_amount) }}
									</div>
								</div>
								<div class="card-item">
									<span class="card-item-label"> {{ $t('distributor.errand.distance') }} </span>
									<div class="card-item-value">
										{{ order.distance_from_you || "-" }} {{ $t('general.distance_unit') }}
									</div>
								</div>
							</template>
							<template #content>
								<div class="card-item">
									<span class="card-item-label">{{ $t('distributor.errand.order_sn') }}: </span>
									<span class="card-item-value">{{
										order.o2o_errand_order_sn
									}}</span>
								</div>
								<div class="card-item">
									<div class="hr-text">
										<span>{{ $t('distributor.errand.order_info') }}</span>
									</div>
								</div>
								<div class="card-item">
									<img
										:src="getAddressIconAssetUrl(order, 'pickup')"
										class="address-icon"
									/>
									{{ order.o2o_errand_order_pickup_address }}
								</div>
								<div class="card-item">
									<div class="hr-text">
										<span>{{ $t('distributor.errand.order_distance') }} {{ order.o2o_errand_order_distance }} {{ $t('general.distance_unit') }}</span>
									</div>
								</div>
								<div class="card-item">
									<img
										:src="getAddressIconAssetUrl(order, 'deliver')"
										class="address-icon"
									/>
									{{ order.o2o_errand_order_deliver_address }}
								</div>
							</template>
							<template #footer>
								<div class="operators">
									<mt-button
										:class="getButtonClass(order)"
										v-if="order.if_pickup"
										@click="pickupErrandOrder(order)"
										>{{ $t('distributor.errand.actions.pick') }}</mt-button
									>
									<mt-button
										:class="getButtonClass(order)"
										v-if="order.if_deliver"
										@click="deliverErrandOrder(order)"
										>{{ $t('distributor.errand.actions.pickup') }}</mt-button
									>
									<mt-button
										:class="getButtonClass(order)"
										v-if="order.if_receive"
										@click="receiveErrandOrder(order)"
										>{{ $t('distributor.errand.actions.done') }}</mt-button
									>
									<mt-button
										class="common-btn default"
										@click="displayOrderMapModel(order)"
										>{{ $t('distributor.errand.actions.map') }}</mt-button
									>
									<mt-button
										class="common-btn default"
										@click="redirectOrderDetailPage(order)"
										>
										<div class="item badge">
											{{ $t('distributor.errand.actions.detail') }}
											<div class="badge-red" v-if="order.hasUnreadMessages"></div>
										</div>
										</mt-button
									>
								</div>
							</template>
						</Card>
					</div>
					<empty-record v-else class="common-empty-record"></empty-record>
				</mt-index-section>
				<!-- 地圖 -->
			</NoNavIndexList>
		</load-more>

		<mt-popup
			v-model="orderMapVisible"
			position="right"
			class="common-popup-wrapper"
		>
			<div class="common-header-wrap">
				<mt-header :title="$t('distributor.dashboard.order_map')" class="common-header">
					<mt-button
						slot="left"
						icon="back"
						@click="orderMapVisible = false"
					></mt-button>
				</mt-header>
			</div>
			<distributor-order-map v-bind:point="point" />
		</mt-popup>
	</div>
</template>

<script>
import { getErrandOrderList } from '../../../api/distributorErrandOrder'
import { Toast, Indicator, MessageBox } from 'mint-ui'
import {
	pickupErrandOrder,
	deliverErrandOrder,
	receiveErrandOrder
} from '@/api/distributorErrandOrder'
import Card from '@/components/basic/card'
import NoNavIndexList from '@/components/basic/no_nav_index_list'
import EmptyRecord from '@/components/EmptyRecord'
import { OrderState } from '@/const/order'
import { mapState, mapMutations } from 'vuex'
import LoadMore from '../../../components/LoadMore'
import { State } from '@/const/distributor'
import DistributorOrderMap from '../common/DistributorOrderMap'

export default {
	components: {
		Card,
		NoNavIndexList,
		EmptyRecord,
		DistributorOrderMap,
		LoadMore
	},
	name: 'DistributorErrand',

	data () {
		return {
			order_id: 0,
			point: false,
			orderMapVisible: false,
			time_interval: false,
			timeout: false,
			latitude: 0,
			longitude: 0,
			load_state: false,
			hasmore: false,
			order_ids: [],
			order_list: false,

			wrapperHeight: 0
		}
	},
	created: function () {
		if (this.user && this.user.store_id != 0) {
			Toast('只有平台配送员有跑腿权限')
			return false
		}
		this.getOrderList(true)
	},
	beforeDestroy: function () {
		clearTimeout(this.timeout)
	},
	computed: {
		...mapState({
			user: (state) => state.distributor.info,
			distributor_point: (state) => state.distributor.point,
			statistics: state => state.distributor.statistics,
			rooms: (state) => state.chatroom.rooms
		}),
		orderGroups: function () {
			const groups = {
				deliver: [],
				pending: []
			}
			for (let i = 0; i < this.order_list.length; i++) {
				const order = this.order_list[i]
				const status = Number(order.o2o_errand_order_state)
				if (status === OrderState.PAY) {
					groups['pending'].push(order)
				} else if ([OrderState.DELIVER, OrderState.SEND].indexOf(status) > -1 && order.o2o_distributor_id === this.user.user_id) {
					groups['deliver'].push(order)
				}
			}
			return groups
		}
	},
	mounted () {
		let _this = this

		if (_this.user) {
			_this.latitude = _this.user.lat
			_this.longitude = _this.user.lng
		}
		this.wrapperHeight = document.documentElement.clientHeight - 90
	},
	methods: {
		...mapMutations({
			distributorStatistics: 'distributorStatistics',
		}),
		getCardHeaderClass (order) {
			return {
				[`order-state-${order.o2o_errand_order_state}-bg`]: true
			}
		},
		getButtonClass (order) {
			const styling = {
				'common-btn': true,
				[`order-state-${order.o2o_errand_order_state}-bg`]: true
			}
			return styling
		},
		getOrderStateText: function (order) {
			return this.$t(`order.errand_send_state.${order.o2o_errand_order_state}`)
		},
		getSectionText (section) {
			return {
				pending: this.$t('distributor.errand.sections.pending'),
				deliver: this.$t('distributor.errand.sections.deliver')
			}[section]
		},
		getAddressIconAssetUrl (order, addressType) {
			const status = Number(order.o2o_errand_order_state)
			if (
				[OrderState.PAY, OrderState.DELIVER].indexOf(status) > -1 &&
				addressType === 'pickup'
			) {
				return require('@/assets/image/svg/animation-current-circle.svg')
			} else if (status === OrderState.SEND && addressType === 'deliver') {
				return require('@/assets/image/svg/animation-current-circle.svg')
			} else {
				return require('@/assets/image/svg/inactive-circle.svg')
			}
		},
		redirectOrderDetailPage (order) {
			this.$router.push({
				name: 'DistributorErrandOrderDetail',
				query: { o2o_errand_order_id: order.o2o_errand_order_id }
			})
		},
		displayOrderMapModel (order) {
			const status = Number(order.o2o_errand_order_state)
			if ([OrderState.PAY, OrderState.DELIVER].indexOf(status) > -1) {
				this.point = {
					lat: order.o2o_errand_order_pickup_lat,
					lng: order.o2o_errand_order_pickup_lng
				}
			} else if (OrderState.SEND === status) {
				this.point = {
					lat: order.o2o_errand_order_deliver_lat,
					lng: order.o2o_errand_order_deliver_lng
				}
			} else {
				this.point = undefined
			}
			this.orderMapVisible = true
		},
		receiveErrandOrder (order) {
			const _this = this
			MessageBox.prompt(this.$t('distributor.errand.op_receive_code'), '', {
				closeOnClickModal: false,
				showInput: true
			}).then(({ value, action }) => {
				if (value) {
					receiveErrandOrder(order.o2o_errand_order_id, value)
						.then((res) => {
							Toast(this.$t('distributor.general.op_successful'))
							// 更新今日统计信息
							this.distributorStatistics({ statistics: res.result.statistics })
							_this.getOrderList(true)
						})
						.catch(function (error) {
							Toast(error.message)
						})
				}
			})
		},
		pickupErrandOrder (order) {
			const _this = this
			pickupErrandOrder(order.o2o_errand_order_id)
				.then((res) => {
					Toast(res.message)
					_this.getOrderList(true)
				})
				.catch(function (error) {
					Toast(error.message)
				})
		},
		deliverErrandOrder (order) {
			const _this = this
			deliverErrandOrder(order.o2o_errand_order_id)
				.then((res) => {
					Toast(res.message)
					_this.getOrderList(true)
				})
				.catch(function (error) {
					Toast(error.message)
				})
		},
		formatOrder (order) {
			order.distance_from_you = order.distance
			order.hasUnreadMessages = this.hasUnreadMessagesByOrderId(order.o2o_errand_order_id)
			return order
		},

		getOrderList (refresh) {
			if (!this.load_state && this.user.state == State.OPENING) {
				this.load_state = true
				clearTimeout(this.timeout)
				if (refresh) {
					Indicator.open()
				}
				this.timeout = setTimeout(() => {
					if (refresh) {
						this.order_list = []
						this.order_ids = []
					}
					getErrandOrderList({ page: 1, per_page: 10 }, 'nearby', {
						except_order_ids: this.order_ids.join(','),
						lat: this.latitude,
						lng: this.longitude
					})
						.then((res) => {
							Indicator.close()
							this.hasmore = res.result.hasmore
							if (res.result.order_ids) {
								this.order_ids = this.order_ids.concat(res.result.order_ids)
							}
							let t_order_list = res.result.order_list

							if (t_order_list) {
								for (var i in t_order_list) {
									t_order_list[i] = this.formatOrder(t_order_list[i])
								}
								if (!this.order_list) {
									this.order_list = t_order_list
								} else {
									this.order_list = this.order_list.concat(t_order_list)
								}
							}
						})
						.catch(function (error) {
							Indicator.close()
							Toast(error.message)
						})

					this.load_state = false
					if (this.$refs.my_loadmore) {
						this.$refs.my_loadmore.$refs.mt_loadmore.onBottomLoaded()
					}
				}, 1500)
			}
		},
		formatTime (timestamp) {
			if (timestamp === 0)
				return this.$t('distributor.errand.deliver_now')

			let time = this.$moment(timestamp, 'X')
			return time.calendar()
		},
		hasUnreadMessagesByOrderId (order_id) {
			const rooms = {}
			Object.keys(this.rooms)
				.filter((room) => room.startsWith(`errand-send-orders:${order_id}`))
				.forEach((room) => { rooms[room] = this.rooms[room] })
			const messages = Object.values(rooms).reduce((prev, current) => {
				return prev.concat(current.messages)
			}, [])
			return messages.some((m) => m.readedAt === 0 && m.clientType !== 'distributor')
		}
	}
}
</script>
<style scoped>
	.setHeight >>> .mint-indexlist-content {
		height: auto !important;
	}
</style>
<style lang="scss">
.card-header {
	color: white !important;
}

.common-empty-record {
	padding: 5%;
}

.address-icon {
	margin-bottom: 0.1rem;
	height: 35px;
	width: 35px;
}

.operators {
	button {
		color: white;
	}
}

.distributor-home-index .page-loadmore-wrapper {
	padding-bottom: 1rem;
	box-sizing: border-box;
}
// .distributor-home-index {
.distributor-home-order {
	margin: 1rem 0.5rem 0 0.5rem;
	overflow: hidden;
	border-radius: 0.5rem;
	.order-title {
		display: flex;
		height: 5rem;
		color: #fff;
		.item {
			flex: 1;
			padding-left: 1rem;
			.title {
				font-size: 0.65rem;
				margin-top: 1.5rem;
			}
			.content {
				font-size: 0.55rem;
				margin-top: 0.2rem;
				strong {
					font-size: 1rem;
					margin-right: 0.2rem;
				}
			}
		}
	}

	.order-content {
		background: #fff;
		font-size: 0.7rem;
		padding: 0.5rem;
		.order-seller,
		.order-buyer {
			position: relative;
			padding: 0.5rem;
			.left {
				position: absolute;
				top: 0;
				bottom: 0;
				i {
					width: 0.5rem;
					height: 0.5rem;
					border-radius: 50%;
					background: #eee;
					display: block;
					top: 50%;
					margin-top: -0.25rem;
					position: absolute;
				}
			}
			.right {
				padding-left: 1.5rem;
				color: #000;
			}
		}
	}

	.operators {
		.round-btn {
			display: block;
			width: 2.5rem;
			height: 2.5rem;
			line-height: 2.5rem;
			text-align: center;
			color: #fff;
			border-radius: 50% !important;
			margin: 0 auto;
		}
	}

	.order-other {
		background: #fff;
		font-size: 0.8rem;
		padding: 0.5rem;
		display: flex;
		text-align: center;
		line-height: 2rem;
		color: #666;
		.item {
			flex: 1;
			position: relative;
		}
		.item::after {
			display: block;
			content: "";
			width: 1px;
			height: 1rem;
			background: #eee;
			position: absolute;
			right: 0;
			top: 50%;
			margin-top: -0.5rem;
			margin-left: 1px;
		}
		.item:last-child::after {
			display: none;
		}
	}

	// }

	.distributor-home-order.errand-buy {
		.order-title {
			background: #f5cc4d;
		}
		.order-seller .left i {
			background: #f5cc4d;
		}
		.round-btn {
			background: #ea5749;
		}
	}
	.distributor-home-order.errand-send {
		.order-title {
			background: #4d9cce;
		}
		.order-seller .left i {
			background: #4d9cce;
		}
		.round-btn {
			background: #ea5749;
		}
	}
}
.common-empty-record .button {
	margin-top: 1rem;
}
</style>
